$(document).ready(function() {
  $('.referrals-trigger').on('click', function(evt) {
    evt.preventDefault();
    $('#referrals-modal').addClass('open');
    $('body').addClass('overflow-hidden');
    $('#navigation-modal').removeClass('open');
    $('#contact-modal').removeClass('open');
    return false;
  });

  $('.close-referrals-modal').on('click', function(evt) {
    evt.preventDefault();
    $('#referrals-modal').removeClass('open');
    $('body').removeClass('overflow-hidden');
    return false;
  });
});
